import React from "react";
import { Button } from "./Buttons";
import { CircularProgress } from "@material-ui/core";

const PageLoader = ({
  error,
  retry,
  timedOut,
  pastDelay,
  backgroundColor = "#ffffff"
}) => {
  if (error || timedOut) {
    return (
      <div className="pageLoader" onClick={retry} style={{ backgroundColor }}>
        <p>Something went wrong.</p>
        <Button variant="outlined">Retry</Button>
      </div>
    );
  } else if (pastDelay) {
    return (
      <div className="pageLoader" style={{ backgroundColor }}>
        <CircularProgress size={30} />
      </div>
    );
  } else {
    return <div className="pageLoader" style={{ backgroundColor }} />;
  }
};
export default PageLoader;



// WEBPACK FOOTER //
// ./src/components/PageLoader.js